import { InformationCircleIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

interface UserError {
  code: string;
  message: string;
}

interface ErrorMessageProps {
  errors?: UserError[] | null;
  className?: string;
}

export const ErrorMessage = ({ errors, className = '' }: ErrorMessageProps) => {
  if (!errors || errors.length === 0) {
    return null;
  }

  return (
    <div className={clsx('text-sm text-red-600', className)}>
      {errors.map((error) => (
        <div key={error.code} className="flex items-start">
          <InformationCircleIcon className="mr-2 mt-0.5 size-4 shrink-0" />
          <span>{error.message}</span>
        </div>
      ))}
    </div>
  );
};
